
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TrashLightIcon from 'Components/icons/TrashLightIcon/TrashLightIcon';

export class TrashIcon extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div role="button" style={{ cursor: 'pointer' }} onClick={this.props.onClick}><TrashLightIcon height={this.props.height} width={this.props.width} /></div>
    );
  }

}
TrashIcon.propTypes = {
  onClick: PropTypes.func,
};

TrashIcon.defaultProps = {
  onClick: () => {},
};
export default TrashIcon;
